/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import I18n from '../../Components/I18n/I18n.component';
import Page from '../../Components/Page/Page.component';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import withServices from '../../Contexts/Services/WithServices.context';
import authActionCreators from '../../State/Store/Auth/Auth.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import './Logout.page.i18n';
import LogoutPagePropTypes from './Logout.page.props';
import logoutPageStyles from './Logout.page.styles';

/**
 * LogoutPageComponent
 * @export
 * @class LogoutPageComponent
 * @extends {React.Component<LogoutPageComponentComposedProps, LogoutPageComponentState>}
 */
export class LogoutPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<LogoutPageComponentProps>}
   * @memberof LogoutPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`LogoutPage`}
   * @memberof LogoutPageComponent
   */
  static displayName = `LogoutPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof LogoutPageComponent
   */
  static propTypes = LogoutPagePropTypes;

  /**
   * Data specific to the `<LogoutPage />` instance
   * @type {LogoutPageComponentState}
   * @memberof LogoutPageComponent
   */
  state = {};

  /**
   * When the Component mounts, logout the user
   * @returns {void} void
   * @memberof LogoutPageComponent
   */
  async componentDidMount() {
    const { services, actions, entry, history } = this.props;
    await services.notificationService.recordAction(`logout`);
    actions
      .authLogout()
      .then(() => {
        return history.replace(entry.postLogoutLink);
      })
      .catch((error) => {
        throw error;
      });
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<LogoutPage />`
   * @memberof LogoutPageComponent
   */
  render() {
    const { classes } = this.props;
    return (
      <Page className={cn(classes.root)} heading="LogoutPage.PageHeading" hideSidebar title="LogoutPage.PageTitle">
        <I18n>LogoutPage.Goodbye</I18n>
      </Page>
    );
  }
}

/** @type {React.ComponentClass<LogoutPageComponentProps>} */
const LogoutPage = compose(
  withServices,
  withEntries,
  withRouter,
  withStyles(themeCreateInjectableStyles(logoutPageStyles), { withTheme: true }),
  connect(
    (state) => ({}),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...authActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(LogoutPageComponent);

export default LogoutPage;
